"use strict";const e=require("react").lazy(()=>Promise.resolve().then(function(){return require("./index-cjs-DA7mdrSX.js")}));exports.DrawerCartV3=e;